// 各环境 微信扫码登录 appid 域名不同appid不一样
export const appId = {
  'production': 'wxa9fa8a037f9771db',
  'test': 'wx215a478552bd132f',
  'dev': 'wx215a478552bd132f'
}
// 各环境 api地址前缀
export const apiUrl = {
  'production': 'https://app.iot.xa.com',
  'test': 'https://dev.iot.xa.com/fm_test',
  'dev': 'https://dev.iot.xa.com'
}
// 各环境 fm地址
export const fmUrl = {
  'production': 'https://iot.xa.com/fmadmin',
  'test': 'http://dev.iot.xa.com:3006/fmadmin',
  'dev': 'http://dev.iot.xa.com:3005/fmadmin'
}
// 各环境 iot官网地址
export const pageUrl = {
  'production': 'https://iot.xa.com',
  'test': 'http://dev.iot.xa.com:10003',
  'dev': 'http://dev.iot.xa.com:10002'
}
// 各环境 微信扫码source地址， 和pageUrl有些许不一样
export const wechatState = {
  'production': 'iot.xa.com',
  'test': 'http://dev.iot.xa.com:10003',
  'dev': 'http://dev.iot.xa.com:10002'
}

export const areaCodeList = [
  {
    value: '86',
    zh: '中国大陆 +86',
    en: 'China +86'
  }, {
    value: '852',
    zh: '中国香港 +852',
    en: 'Hong Kong +852'
  }, {
    value: '853',
    zh: '中国澳门 +853',
    en: 'Macao +853'
  }, {
    value: '886',
    zh: '中国台湾 +886',
    en: 'Taiwan +886'
  }, {
    value: '1',
    zh: '美国 +1',
    en: 'United States +1'
  }, {
    value: '81',
    zh: '日本 + 81',
    en: 'Japan + 81'
  }, {
    value: '61',
    zh: '澳大利亚 + 61',
    en: 'Australia + 61'
  }, {
    value: '63',
    zh: '菲律宾 + 63',
    en: 'Philippines + 63'
  }
]



// WEBPACK FOOTER //
// ./src/utils/constant.js